export default "__VITE_ASSET__D2$WwpTz__"